export enum PayMethod {
  ALIPAY = 'ALIPAY',
  WEPAY = 'WEPAY',
  BANKCARD = 'BANKCARD',
  ECNY = 'ECNY',
  WEPAYQR = 'WEPAYQR',
  ALIPAYQR = 'ALIPAYQR',
}

/** 卖币收款方式弹窗内的固定展示顺序（挂单卖币 / 快速卖币一致） */
export const SELL_RECEIVE_PAY_METHOD_ORDER: PayMethod[] = [
  PayMethod.BANKCARD,
  PayMethod.ALIPAY,
  PayMethod.WEPAY,
  PayMethod.ECNY,
]

export const paymentMethodNames: Record<PayMethod, string> = {
  [PayMethod.BANKCARD]: '银行卡',
  [PayMethod.WEPAY]: '微信',
  [PayMethod.ALIPAY]: '支付宝',
  [PayMethod.ECNY]: '数字人民币',
  [PayMethod.WEPAYQR]: '微信收款码',
  [PayMethod.ALIPAYQR]: '支付宝收款码',
}

/** 支付密码使用场景 */
export enum PinScope {
  /** 修改支付密码 */
  ChangePIN = 'change_pin',
  /** 用户认证商家 */
  ApplyToAgent = 'apply_to_agent',
  /** 商家申请退还保证金 */
  ApplyAgentRefund = 'apply_agent_refund',
  /** 转账确认(两种转账方式都用此枚举) */
  TransferConfirm = 'transfer_confirm',
  /** 增加支付方式 */
  AddPayMethod = 'add_pay_method',
  /** 发货确认 */
  DeliveryConfirm = 'delivery_confirm',
}

export enum OrderStatus {
  /** 待确认 */
  OrderPrepare = 0,
  /** 待付款 */
  OrderAgree = 1,
  /** 待发货 */
  OrderCurrencyFaitPaid = 2,
  /** 已完成 */
  OrderCurrencyPaid = 3,
  /** 买家取消 */
  OrderBuyerCancel = 4,
  /** 异常 */
  OrderUnusual = 5,
  /** 卖家取消 */
  OrderSellerCancel = 6,
  /** 工单判定退币 */
  OrderAdminReturn = 7,
  /** 工单判定放币 */
  OrderAdminSend = 8,
  /** 买家超时 */
  OrderExpiredByBuyer = 11,
  /** 卖家超时 */
  OrderExpiredBySeller = 12,
}

export enum AdsStatus {
  /** 暂时没用 */
  AdsPrepare = 0,
  /** 上架 */
  AdsOn = 1,
  /** 下架 */
  AdsOff = 2,
  /** 暂停 */
  AdsPause = 3,
  /** 完成 */
  AdsDone = 4,
}
/** 交易方向 */
export enum Side {
  Buy = 1,
  Sell = 2,
}

/** 维权状态 */
export enum RightProtectStatus {
  /** 未维权（可发起维权） */
  None = 0,
  /** 已发起维权，待提交材料 */
  Initiated = 1,
  /** 已提交材料，待审核 */
  MaterialSubmitted = 2,
  /** 已申诉 */
  Appealed = 3,
  /** 后台判定：维权成功 */
  AdminApproved = 4,
  /** 后台判定：维权失败 */
  AdminRejected = 5,
  /** 已取消维权 */
  Cancelled = 6,
}

export enum UserStatus {
  Enable = 1,
  TradeFrozen = 3,
}

export enum ExpireReason {
  /* 卖家确认超时 */
  ConfirmTimeOut = 'confirm_timeout',
  /* 买家转账超时 */
  TransferTimeOut = 'transfer_timeout',
  /* 卖家发货超时 */
  DeliverTimeOut = 'deliver_timeout',
}

export enum UnusualOrderStatus {
  /** 待受理 */
  UnusualOrderPending = 0,
  /** 锁定/处理中 */
  UnusualOrderLock = 1,
  /** 发货 */
  UnusualOrderSend = 2,
  /** 退回 */
  UnusualOrderReturn = 3,
  /** 恢复 */
  UnusualOrderRecover = 4,
  /** 取消 */
  UnusualOrderCancel = 5,
}

export const statusMap: Record<OrderStatus, string> = {
  [OrderStatus.OrderPrepare]: '待处理',
  [OrderStatus.OrderAgree]: '待支付',
  [OrderStatus.OrderCurrencyFaitPaid]: '待发货',
  [OrderStatus.OrderCurrencyPaid]: '已完成',
  [OrderStatus.OrderBuyerCancel]: '买家取消',
  [OrderStatus.OrderUnusual]: '异常',
  [OrderStatus.OrderSellerCancel]: '卖家取消',
  [OrderStatus.OrderAdminReturn]: '工单判定退币',
  [OrderStatus.OrderAdminSend]: '工单判定放币',
  [OrderStatus.OrderExpiredByBuyer]: '买家超时',
  [OrderStatus.OrderExpiredBySeller]: '卖家超时',
}
export const longStatusMap: Record<OrderStatus, string> = {
  [OrderStatus.OrderPrepare]: '等待卖家确认',
  [OrderStatus.OrderAgree]: '等待买家支付',
  [OrderStatus.OrderCurrencyFaitPaid]: '等待卖家发货',
  [OrderStatus.OrderCurrencyPaid]: '已完成',
  [OrderStatus.OrderBuyerCancel]: '买家已取消订单',
  [OrderStatus.OrderUnusual]: '异常',
  [OrderStatus.OrderSellerCancel]: '卖家已取消订单',
  [OrderStatus.OrderAdminReturn]: '工单判定退币',
  [OrderStatus.OrderAdminSend]: '工单判定放币',
  [OrderStatus.OrderExpiredByBuyer]: '等待买家支付 超时',
  [OrderStatus.OrderExpiredBySeller]: '等待卖家发货 超时',
}

export const unusualOrderStatusMap: Record<UnusualOrderStatus, string> = {
  [UnusualOrderStatus.UnusualOrderPending]: '工单处理中',
  [UnusualOrderStatus.UnusualOrderLock]: '工单处理中',
  [UnusualOrderStatus.UnusualOrderSend]: '工单判定发货',
  [UnusualOrderStatus.UnusualOrderReturn]: '工单判定退币',
  [UnusualOrderStatus.UnusualOrderRecover]: '工单恢复交易',
  [UnusualOrderStatus.UnusualOrderCancel]: '工单取消交易',
}
